module.exports = __webpack_public_path__ + "img/engagementbox@2x.6ee2392.webp";